/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow-thin': {
    width: 17,
    height: 11,
    viewBox: '0 0 17 11',
    data: '<path pid="0" d="M1 1l7.5 9.152L16 1" _stroke="#000"/>'
  }
})
